<template>
  <v-card tile>
    <v-toolbar card dark color="teal lighten-2">
      <v-toolbar-title>Código: {{ codigosie }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat @click="$emit('close')">Cerrar</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-progress-linear v-if="mloading" :indeterminate="true"></v-progress-linear>
      <v-container grid-list-lg fluid class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 sm8 id="titulo">
            <v-card>
              <v-card-text>
                <h4 class="grey--text text--darken-2">Datos del Centro de Capacitación</h4>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-text>
                <v-form ref="form_curso">
                  <v-layout row wrap>
                    <v-flex xs12 class="my-0 py-0">
                      <v-card-title class="grey lighten-4 py-1 px-1">
                        <h3 class="grey--text text--darken-1">Datos del Curso</h3>
                      </v-card-title>
                      <v-divider class="mb-0"></v-divider>
                    </v-flex>

                    <v-flex xs12 md12 lg12 class="py-0">
                      <v-text-field type="text" label="Cursos autorizados registrado" v-model="mcurso.curso
                      " disabled>
                      </v-text-field>
                      <!--<v-select :items="mcurso" label="Cursos autorizados vigentes" item-text="curso" item-value="id"
                        v-model="mcurso.curso_capacitacion" 
                        :rules="[v => !!v || 'Seleccione una opción']" required></v-select>-->
                    </v-flex>

                    <v-flex xs12 sm6 class="py-0">
                      <v-menu v-model="fechaInicio" :close-on-content-click="false" :nudge-right="40" lazy
                        transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field v-model="mcurso.fecha_inicio" label="Fecha de Inicio" append-icon="event"
                          disabled v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="mcurso.fecha_inicio" @input="fechaInicio = false"></v-date-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 sm6 class="py-0">
                      <v-menu v-model="fechaFin" :close-on-content-click="false" :nudge-right="40" lazy
                        transition="scale-transition" offset-y full-width min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field v-model="mcurso.fecha_fin" label="Fecha de Finalización" append-icon="event"
                          disabled v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="mcurso.fecha_fin" @input="fechaFin = false">
                        </v-date-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 sm6 lg6 class="py-0">
                      <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                        :return-value.sync="mcurso.hora_inicio" transition="scale-transition" offset-y max-width="290px"
                        min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="mcurso.hora_inicio" label="Hora de inicio" prepend-icon="schedule" 
                            v-bind="attrs" v-on="on" disabled></v-text-field>
                        </template>
                        <v-time-picker v-if="menu1" v-model="mcurso.hora_inicio" full-width format="24hr"
                          @click:minute="$refs.menu1.save(mcurso.hora_inicio)">
                        </v-time-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 sm6 lg6 class="py-0">
                      <v-menu ref="menu" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                        :return-value.sync="mcurso.hora_fin" transition="scale-transition" offset-y max-width="290px"
                        min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="mcurso.hora_fin" label="Hora de finalización" prepend-icon="schedule"
                            v-bind="attrs" v-on="on" disabled>
                          </v-text-field>
                        </template>
                        <v-time-picker v-if="menu2" v-model="mcurso.hora_fin" full-width format="24hr"
                          @click:minute="$refs.menu.save(mcurso.hora_fin)">
                        </v-time-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 sm4 class="pt-0 pb-1">
                      <v-text-field type="number" label="Cupo máximo de participantes" v-model="mcurso.cupo_maximo"
                      disabled>
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm4 class="pt-0 pb-1">
                      <v-text-field type="number" label="Carga horaria" v-model="mcurso.carga_horaria"
                      disabled></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm4 class="pt-0 pb-1">
                      <v-text-field type="number" label="Tiempo de duración (semanas)" v-model="mcurso.tiempo_duracion"
                      disabled>
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 class="my-0 py-0">
                      <v-card-title class="grey lighten-4 py-1 px-1">
                        <h4 class="grey--text text--darken-1">Días registrados para el curso </h4>
                      </v-card-title>
                      <v-divider class="mb-0"></v-divider>
                    </v-flex>

                    <v-flex xs12 md12 lg12 class="py-0">
                      <v-text-field type="text" label="Días registrados" v-model="mcurso.dias"
                      disabled>
                      </v-text-field>
                    </v-flex>

                    <!--<v-flex xs1 sm2 lg2 class="pt-0 pb-1">
                      <v-checkbox v-model="mcurso.lunes" :label="'Lunes'" disabled></v-checkbox>
                    </v-flex>
                    <v-flex xs1 sm2 lg2 class="pt-0 pb-1">
                      <v-checkbox v-model="mcurso.martes" :label="'Martes'" disabled></v-checkbox>
                    </v-flex>
                    <v-flex xs1 sm2 lg2 class="pt-0 pb-1">
                      <v-checkbox v-model="mcurso.miercoles" :label="'Miércoles'" disabled></v-checkbox>
                    </v-flex>
                    <v-flex xs1 sm2 lg2 class="pt-0 pb-1">
                      <v-checkbox v-model="mcurso.jueves" :label="'Jueves'" disabled></v-checkbox>
                    </v-flex>
                    <v-flex xs1 sm2 lg2 class="pt-0 pb-1">
                      <v-checkbox v-model="mcurso.viernes" :label="'Viernes'" disabled></v-checkbox>
                    </v-flex>
                    <v-flex xs1 sm2 lg2 class="pt-0 pb-1">
                      <v-checkbox v-model="mcurso.sabado" :label="'Sábado'" disabled></v-checkbox>
                    </v-flex>-->

                    <v-flex xs12 class="my-0 py-0">
                      <v-card-title class="grey lighten-4 py-1 px-1">
                        <h4 class="grey--text text--darken-1">Facilitador asignado al curso
                        </h4>
                      </v-card-title>
                      <v-divider class="mb-0"></v-divider>
                    </v-flex>

                    <v-flex xs12 md12 lg12 class="py-0">
                      <v-text-field type="text" label="Docente asignado" v-model="mcurso.nombre +' '+ mcurso.paterno +' '+ mcurso.materno"
                      disabled>
                      </v-text-field>
                      <!--<v-select :items="facilitadores" label="Docentes registrados" item-text="nombre" item-value="id"
                        v-model="mcurso.facilitador" 
                        :rules="[v => !!v || 'Seleccione una opción']" required></v-select> -->
                    </v-flex>

                  </v-layout>

                </v-form>

              </v-card-text>
            </v-card>

          </v-flex>

        </v-layout>
      </v-container>
    </v-card-text>
    <div style="flex: 1 1 auto;"></div>
  </v-card>
</template>
<script>
import Service from "../services/general";
export default {
  name: "detalle-curso",
  props: [ 'mloading', 'mcurso' ],
  data: () => ({

    /*cursos: [],
    curso: {
      curso_capacitacion: '',
      carga_horaria: '',
      duracion: '',
      time: '',
      time1: '',
      fecha_inicio: '',
      fecha_fin: '',
      cupo: '',
      lunes: true,
      martes: true,
      miercoles: true,
      jueves: true,
      viernes: true,
      sabado: false,
      facilitador: ''
    },*/
    menu2: false,
    menu1: false,
    fechaFin: false,
    fechaInicio: false,
    facilitadores: [],

    codigosie: '',

  }),
  mounted() {
      this.dparams = Service.getParams(); 
      this.codigosie = this.dparams.ie_id;
      
      //console.log(mcurso);
      //this.getcursosAutorizados();
            
    },
  methods: {
      
      /*getcursosAutorizados() { 
        Service.cursosAutorizados(this.dparams.ie_id).then(response => {
          this.cursos = response.data.cursos; 
          this.facilitadores = response.data.facilitadores; 
        }).catch(error => {
          console.error('Error al cargar datos', error);
        });
      }*/
  }
};
</script>

<style>
#titulo{margin: 0px auto;}
#contenido{margin: 0px auto;}
</style>